import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import WhatsNewContent from '../WhatsNewModal/WhatsNewContent';
const queryClient = new QueryClient();
export default function WhatsNewContentWrapper(props) {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(WhatsNewContent, Object.assign({}, props))));
}
